module.exports = __webpack_public_path__ + "img/icon-check.ce62c51a.svg";